{
  "conversation": {
    "agent_mode": {
      "saved": "Valgt profil",
      "agents": {
        "kaila": {
          "name": "KAILA Jura",
          "description": "Juridisk assistent"
        },
        "kfc": {
          "name": "KAILA Kommune",
          "description": "Denne samtale er baseret på sagsbehandlerprofilen. Her bliver kommunens uploadede dokumenter brugt i svaret."
        },
        "replay": {
          "name": "Genafspilning",
          "description": "Afspil tidligere samtaler"
        },
        "mock": {
          "name": "Mock",
          "description": "Simuleret agent"
        }
      }
    },
    "ask_kaila_back": {
      "submit_button": "Svar",
      "user_selected": "Jeg har valgt følgende muligheder:",
      "mode_question": "Spørgsmål",
      "mode_suggestion": "Forslag",
      "switch_mode": "Kør dybdeforskning",
      "keep_previous_mode": "Behold {{previous}}",
      "about_deep": "Dybdegående research kan give dig et mere fuldstændigt svar",
      "deep_description": "Grundig research tjekker lovgivning, retspraksis og relaterede kilder, før du svarer, så du kan få mere kontekst og flere referencer.",
      "kfc_title": "Hvilke områder bør jeg fokusere på?",
      "kfc_description": "Jeg har identificeret følgende områder, der kan være relevante for dit spørgsmål. Vælg alle relevante muligheder.",
      "skip": "Spring over"
    },
    "references_panel": {
      "empty_state": "Ingen kilder til dette svar.",
      "source_validation": {
        "button": "Vis",
        "toggle_type": "type",
        "toggle_name": "titel"
      },
      "error": {
        "title": "Der skete en fejl",
        "description": "Der skete en fejl under indlæsningen af kilder"
      },
      "go_to_document": "Gå til dokument",
      "header": "Kilder",
      "no_content_disclaimer": "Forhåndsvisning er ikke tilgængelig",
      "open_in_karnov": "Åbn i Karnov Online",
      "ai_generated_summary": {
        "text": "Resumé af KAILA",
        "tooltip": "Retspraksis sammenfattes af AI, for at give et hurtigt overblik."
      }
    },
    "annotation_type": {
      "karnov": "Karnovs noter",
      "lexino": "",
      "nj_annotation": ""
    },
    "conversation_error": {
      "title": "Noget gik galt",
      "description": "Noget gik galt med samtalen. Prøv at genindlæse siden eller kontakt kundeservice.",
      "guide": "Hjælp os med at fejlsøge problemet, ved at dele indholdet af samtalen.",
      "send_to_support": "Del samtalen med os",
      "success_title": "Fejlrapport sendt",
      "success_message": "Tak, din fejlrapport er sendt"
    },
    "conversation_feedback": {
      "cancel": "Spring over",
      "confirmation": "Tak for at dele din feedback",
      "conversation_rating_question": "Begrund din bedømmelse ",
      "description": "Vælg den kategori, som passer bedst til din feedback. Detaljeret feedback gør det muligt at forbedre KAILAs svar fremadrettet. Når du indsender feedback, giver du samtykke til, at vi kan se din feedback, hele samtalen (spørgsmål og svar), eventuelle kilder og vedhæftede filer.",
      "error": "Noget gik galt, prøv evt. igen",
      "feedback_modal": "Vi vil gerne have din feedback",
      "consent_checkbox": "Jeg giver samtykke til at blive kontaktet, hvis der er brug for yderligere oplysninger.",
      "options": {
        "1": {
          "title": "Historiske retskilder",
          "placeholder": "Svaret er baseret på ophævede retskilder"
        },
        "2": {
          "title": "Hallucinationer",
          "placeholder": "Svaret indeholder opdigtede referencer eller konklusioner uden valide retskilder til at understøtte svaret"
        },
        "3": {
          "title": "Manglende retskilder",
          "placeholder": "Svaret mangler referencer til relevante retskilder. Angiv gerne de(n) manglende retskilde(r)"
        },
        "4": {
          "title": "Forkert anvendelse af juridisk metode",
          "placeholder": "Fejlfortolkning af retskilder"
        },
        "5": {
          "title": "Forældet information",
          "placeholder": "Svaret inddrog ikke de nyeste retskilder"
        },
        "6": {
          "title": "Andet",
          "placeholder": "Oplevede du andre problemer med svaret? Giv os besked"
        }
      },
      "submit": "Indsend feedback",
      "textarea_placeholder": "Uddyb gerne...",
      "title": "Tak for at dele din feedback"
    },
    "conversation_sources": "Kilder",
    "prompt_templates": {
      "create_title": "Gem ny prompt",
      "create_description": "Gem prompts til senere brug. Det kan være nyttigt til opgaver eller spørgsmål, du ofte gentager eller starter på samme måde.",
      "edit_title": "Rediger prompt",
      "title_label": "Titel",
      "title_placeholder": "",
      "content_label": "Din prompt",
      "content_placeholder": "",
      "save": "Gem",
      "cancel": "Annuller",
      "delete": "Slet",
      "save_success": "Prompt gemt",
      "save_error": "Prompten kunne ikke gemmes",
      "validation_error": "Kontrollér titlen og prompten, og prøv igen",
      "delete_success": "Prompt slettet",
      "delete_error": "Prompten kunne ikke slettes",
      "delete_confirm": {
        "title": "Slet prompt",
        "question": "Er du sikker på, at du vil slette prompten?",
        "confirm": "Slet",
        "cancel": "Annuller"
      },
      "title": "Gemte prompts",
      "description": "Hvis du ofte stiller de samme spørgsmål eller genbruger den samme kontekst, kan du gemme dine prompts her og genbruge dem med et enkelt klik, når som helst du har brug for det.",
      "new_prompt": "Ny prompt",
      "search_placeholder": "Søg bland prompts...",
      "search_aria": "Søg bland gemte prompts",
      "search_clear": "Ryd søgning",
      "see_details": "Vis detaljer",
      "close_details": "Skjul detaljer",
      "edit": "Rediger",
      "edit_prompt_aria": "Rediger prompt: {{title}}",
      "trigger_label": "Prompts",
      "trigger_tooltip": "Åbn gemte prompts",
      "no_results": "Ingen resultater",
      "close": "Luk gemte prompts",
      "delete_prompt_aria": "Slet prompt: {{title}}",
      "error": {
        "title": "Der opstod en fejl",
        "description": "Der opstod en fejl under indlæsning af gemte prompter"
      },
      "pagination": "Sideinddeling",
      "pagination_previous": "Forrige",
      "pagination_next": "Næste",
      "pagination_previous_aria": "Gå til forrige side",
      "pagination_next_aria": "Gå til næste side",
      "pagination_page_aria": "Gå til side {{page}}",
      "attachment_warning": "Uploadede filer og henvisninger understøttes endnu ikke for gemte prompts.",
      "suggest": "Foreslå",
      "generating_title": "Genererer titel",
      "title_error": "Kunne ikke generere en titel."
    },
    "message_done_toast": "Din samtale er færdig. Klik her for at gå til samtalen",
    "message_done_toast_with_subject": "Din samtale \"{{subject}}\" er færdig. Klik her for at gå til samtalen",
    "error": {
      "no_access": {
        "description": "Vælg en anden samtale eller start en ny samtale i menuen",
        "title": "Du har ikke adgang til denne samtale"
      },
      "not_found": {
        "description": "Vælg en anden samtale eller start en ny samtale i menuen",
        "title": "Samtale ikke fundet"
      },
      "unknown": {
        "description": "Prøv at genindlæse siden",
        "title": "Din samtale kan ikke hentes i øjeblikket"
      }
    },
    "message_action": {
      "cancel_edit_message": "Fortryd redigering",
      "copy_message": "Kopier",
      "delete_failed_user_message": "Slet",
      "downvote_message": "Synes ikke om",
      "upvote_message": "Synes om",
      "edit_message": "Rediger spørgsmål",
      "edit": "Rediger",
      "export_docx": "Eksporter til Word",
      "export": "Eksporter",
      "more_actions": "Flere handlinger",
      "print_message": "Udskriv",
      "regenerate_message": "Generer svar igen",
      "save_message": "Gem prompten",
      "save": "Gem",
      "skip_to_content": "Gå til toppen af besked",
      "to_top": "Til toppen"
    },
    "export_docx": {
      "success": "Dokument eksporteret",
      "error": "Kunne ikke eksportere dokument",
      "question_heading": "Spørgsmål",
      "answer_heading": "Svar"
    },
    "prompt_input": {
      "disclaimer_text": "Vores AI bruger kilder fra Karnovs database, men kan lave fejl. Dobbelttjek derfor vigtige oplysninger.",
      "disclaimer_link": {
        "prefix": "",
        "text": "",
        "suffix": "",
        "href": ""
      },
      "placeholder": "Skriv dit spørgsmål",
      "placeholder_follow_up": "Skriv et opfølgende spørgsmål",
      "document_tag": "Henvis til dokument"
    },
    "document_tagging": {
      "placeholder": "Skriv dokumentets navn her",
      "prompt_input_suggestion": "Henvis til dokument",
      "clear_input": "Ryd søgetekst",
      "finding_documents": "Henter dokumenter...",
      "search_for_documents_title": "Søg efter et dokument fra Karnov Online",
      "search_for_documents_description": "Angiv dokumentets titel eller referencenummer",
      "no_documents_found_title": "Fandt ingen dokumenter",
      "no_documents_found_description": "Skriv en gyldig titel eller reference, eller gå till Karnov Online og find dokumentet.",
      "kfc_disclaimer": "Kaila har allerede adgang til dine lokale dokumenter, så de behøver ikke at blive tagget.",
      "error_title": "Noget gik galt",
      "error_description": "Forsøg at genindlæse siden",
      "title": "Søgeresultater"
    },
    "prompt_button": {
      "label": "Spørg Kaila",
      "stop": "Annuller"
    },
   "research_mode": {
      "light": {
        "name": "Let søgning",
        "short": "Let",
        "description": "Til hurtige spørgsmål. Henter et begrænset udvalg af kilder; ingen omfattende gennemgang."
      },
      "regular": {
        "name": "Regelmæssig søgning",
        "short": "Regelmæssig",
        "description": "Søger i alle Karnovs kilder og udarbejder et struktureret svar."
      },
      "deep": {
        "name": "Dybdegående søgning",
        "short": "Dyb",
        "description": "Udfører en omfattende søgning ved komplekse spørgsmål. Tager længere tid"
      }
    },
    "user_message": {
      "cancel_button": "Annuller",
      "submit_button": "Gem og Indsend"
    },
    "table_view": {
      "close_button": "Luk fuld størrelse af tabel",
      "modal_title": "Tabel i fuld størrelse",
      "open_button": "Åbn i fuld størrelse"
    },
    "loading_header": {
      "estimated_time": "Estimeret ventetid",
      "less_than_a_minute": "Mindre end ét minut",
      "minutes_one": "{{count}} minut",
      "minutes_other": "{{count}} minutter",
      "slow_answer_disclaimer": "Genererer et komplekst svar. Dette kan tage lidt ekstra tid."
    },
    "clipboard": {
      "copy_success": "Indhold kopieret",
      "copy_error": "Kopiering af indhold mislykkedes"
    }
  },
  "conversation_history": {
    "load_more_button": "Indlæs flere",
    "load_more_title": "Viser side {{currentPage}} af {{totalPages}}",
    "no_more_conversations": "Du har nået slutningen af din samtalehistorik.",
    "go_to_top": "Gå til toppen af listen",
    "close_conversation_history_panel": "Skjul historik",
    "close_conversation_sidepanel": "Luk sidepanel",
    "conversation_expiration_one": "{{count}} dag",
    "conversation_expiration_other": "{{count}} dage",
    "conversation_expiration_tooltip_one": "Udløber om 1 dag. Fastgør eller send en ny besked for at beholde dine samtaler.",
    "conversation_expiration_tooltip_other": "Udløber om {{count}} dage. Fastgør eller send en ny besked for at beholde dine samtaler.",
    "conversation_expiration_expired_tooltip": "Dine samtaler gemmes i 90 dage efter den seneste aktivitet. Derefter slettes de automatisk.",
    "conversation_action": {
      "delete": "Slet samtale",
      "pin": "Fastgør",
      "rename": "Omdøb",
      "unpin": "Frigør"
    },
    "conversation_delete_modal": {
      "cancel_button": "Annullér",
      "delete_button": "Slet",
      "title": "Slet samtale",
      "question": "Er du sikker på, at du vil slette samtalen"
    },
    "error": {
      "description": "Prøv at genindlæse siden",
      "title": "Din historik kan ikke hentes i øjeblikket"
    },
    "expired_conversations_onboarding": "For at beskytte dine data vil samtaler, der har været inaktive i mere end 90 dage, nu blive permanent slettet.",
    "history": "Historik",
    "history_expiration_time": "90 dage",
    "history_short": "Historik",
    "history_tooltip": "Dine samtaler gemmes i 90 dage efter den seneste aktivitet. Derefter slettes de automatisk.",
    "new_conversation_button": "Ny samtale",
    "new_conversation_button_short": "Ny",
    "new_conversation_subject": "Ny samtale",
    "new_document_analysis_button": "KAILA Dokumentanalyse",
    "new_document_analysis_button_beta_label": "BETA",
    "new_document_analysis_button_new_label": "Nyhed",
    "new_document_analysis_button_short": "Analyse",
    "flow_access_link": "KAILA Flow",
    "flow_access_link_short": "Flow",
    "open_conversation_history_panel": "Vis historik",
    "open_conversation_sidepanel": "Åbn sidepanel",
    "panel_header": "Menu",
    "pinned": "Fastgjort",
    "edit_conversation_subject_submit": "Gem ændringerne til samtale emnet",
    "edit_conversation_subject_cancel": "Annuller ændringerne til samtale emnet",
    "search_in_conversation": "Find samtale",
    "search_in_conversation_description": "Søg i samtaler efter emne",
    "search_in_conversation_clear": "Ryd søgning",
    "empty_search_in_conversation": "Ingen samtaler blev fundet med søgningen: \"{{searchTerm}}\"",
    "toast_notification": {
      "conversation_pinned_error": "Fastgørelse af samtale mislykkedes",
      "conversation_unpinned_error": "Frigørelse af samtale mislykkedes",
      "conversation_pinned_successful": "Samtale fastgjort",
      "conversation_unpinned_successful": "Samtale frigjort",
      "conversation_delete_success": "Samtale slettet",
      "conversation_delete_error": "Samtalen blev ikke slettet",
      "subject_editting_error": "Ændringer kunne ikke gennemføres",
      "subject_editting_sucessful": "Ændringer gennemført"
    },
    "today": "I dag",
    "yesterday": "I går",
    "latest_7_days": "Seneste 7 dage",
    "latest_15_days": "Seneste 15 dage",
    "latest_30_days": "Seneste 30 dage",
    "latest_60_days": "Seneste 60 dage",
    "more_than_60_days": "Over 60 dage - Udløber snart",
    "expired": "Udløber snart",
    "retention_info": "Dine aktive samtaler gemmes i 90 dage. Derefter slettes de automatisk for at beskytte dit privatliv."
  },
  "file_upload": {
    "capacity_usage": "{{space}}% plads brugt",
    "content_type": {
      "application/pdf": "Pdf",
      "application/msword": "Word",
      "application/vnd.openxmlformats-officedocument.wordprocessingml.document": "Word",
      "unknown": "Ukendt",
      "unsupported": "Filtype ikke understøttet"
    },
    "drag_and_drop_label_one": "Træk og slip dit dokument her",
    "drag_and_drop_label_other": "Træk og slip dine dokumenter her",
    "file_upload_limit_exceeded": "Du har valgt for mange filer.",
    "file_upload_limit_reached": "Du kan ikke uploade flere dokumenter.",
    "header": "Upload dit dokument for at komme i gang",
    "subheader": "Kan være Word (.docx) eller PDF",
    "upload_button": "Upload dokument",
    "upload_status": {
      "error": "Fejl",
      "uploading": "Uploader",
      "deleting": "Sletter"
    },
    "error": {
      "above_page_count_limit": "Filerne må ikke indeholde mere end 400 sider.",
      "above_word_count_limit": "Filerne må ikke indeholde mere end 100.000 ord",
      "above_file_size_limit": "Filerne må ikke fylde mere end 20 MB.",
      "content_too_large": "Filerne må ikke fylde mere end 20 MB.",
      "malformed_file_content": "Filen kunne ikke læses - den ser ud til at være beskadiget",
      "deletion_error": "Der skete en fejl under sletning af filen.",
      "invalid_mime_type": "Denne filtype understøttes ikke. Du kan kun uploade Word-filer (.docx) og PDF-filer.",
      "exceeds_token_limit": "Dette dokument overskrider pladsgrænsen og vil ikke blive brugt.",
      "upload_error": "Der skete en fejl under upload.",
      "virus_detected": "Den uploadede ser ud til at indeholde en virus."
    }
  },
  "frequently_asked_questions": {
    "footer": {
      "customer_service": "Kundeservice",
      "customer_service_url": "https://www.karnovgroup.dk/om-os/kontakt",
      "terms": "Brugerbetingelser",
      "terms_url": "https://pro.karnovgroup.dk/tos_acceptance"
    },
    "help": "Hjælp",
    "helpful_question_answer_title": "Besvarede dette dit spørgsmål?",
    "helpful_question_answer_button_yes": "Ja",
    "helpful_question_answer_button_no": "Nej",
    "thank_you_for_feedback_description": "Dit input hjælper med at forbedre denne information for alle.",
    "thank_you_for_feedback_title": "Tak for din feedback!",
    "thank_you_for_feedback_toast_notification": "Tak for din feedback",
    "related_questions": "Relaterede spørgsmål"
  },
  "help_and_feedback": {
    "button": "Hjælp & Feedback",
    "dropdown_options": {
      "help": "Hjælp",
      "tutorial": "Vejledning",
      "user_carousel_onboarding": "Onboarding"
    }
  },
  "kfc": {
    "description": "Det første svar baseres på kilder i Karnovs database, mens dette supplerende svar bygger på din kommunes interne dokumenter under den forudsætning, at disse er uploadet og tilgængelige i Karnov Kommune. Begge svar inkluderer referencer og links til de kilder, de tager udgangspunkt i."
  },
  "message": {
    "create_conversation_message_error": "Kunne ikke sende.",
    "create_conversation_message_retry": "Prøv igen",
    "streaming_waiting": "Afventer svar",
    "streaming_canceled": "Svar stoppet",
    "streaming_error": "Der opstod en fejl under generering af svaret",
    "streaming_error_retry": "Generer igen",
    "streaming_error_code": "Fejlkode",
    "streaming_error_conversation": "Samtale",
    "streaming_reconnect_error": "Der opstod en fejl under forsøg på at genoprette forbindelsen",
    "streaming_reconnect_error_retry": "Forsøg at genoprette forbindelse",
    "thoughts": "Refleksioner",
    "follow_up": "Du kan også spørge",
    "follow_up_description": "De opfølgende prompt-forslag hjælper dig til at komme videre i din samtale. Du kan vælge et af forslagene og tilpasse dem din konkrete situation ved at give mere kontekst, styre eller udvide samtalen.",
    "updated_at": "{{updatedAt, date}}"
  },
  "no_access": {
    "title": "Du har ikke adgang til dette indhold",
    "description": "Dette indhold kræver adgang til et produkt, som ikke er inkluderet i dit nuværende abonnement.",
    "refresh_access": {
      "button": "Opdater adgang",
      "description": "Hvis du mener, at der er tale om en fejl, kan du prøve at opdatere dine adgangsindstillinger – det vil synkronisere dit abonnement og låse det indhold op, du har adgang til.",
      "contact_support": "Hvis problemet fortsætter, bedes du kontakte vores kundeservice."
    },
    "contact_info": {
      "header": "Vi sidder klar til at hjælpe",
      "description": "Ring eller skriv til vores kundeservice og hør om forskellige licenser",
      "link": {
        "prefix": "",
        "text": "",
        "suffix": "",
        "href": ""
      },
      "phone": "+45 33 74 07 00",
      "email": "kundeservice@karnovgroup.com"
    }
  },
  "system_messages": {
    "_ANALYSING_DOCUMENTS_": "Analyserer dokumenter",
    "_ANALYSING_QUERY_": "Analyserer spørgsmålet",
    "_ANALYSING_SOURCES_": "Analyserer kilder",
    "_FETCHING_SIMILAR_DOCUMENTS_": "Søger efter kilder",
    "_FETCHING_LAW_DOCUMENTS_": "Søger efter lovreferencer",
    "_FETCHING_PREPATORY_WORK_DOCUMENTS_": "Søger efter forarbejder",
    "_FETCHING_LITERATURE_DOCUMENTS_": "Søger efter litteraturreferencer",
    "_GENERATING_ANSWER_": "Genererer et svar"
  },
  "document_tag_tooltip": "Klik eller skriv ”@” for at henvise til et dokument",
  "input_character_limit_reached": "Maksimalt antal tegn er nået",
  "user_carousels": {
    "dismiss": "Fortsæt",
    "carousels": {
      "onboarding": {
        "title": "Velkommen til KAILA",
        "read_more_url": "",
        "screens": {
          "welcome": {
            "description": "Kombinationen af hverdagssprog og Karnovs AI model gør din juridiske informationssøgning nemmere",
            "header": "Find svar på dine juridiske spørgsmål"
          },
          "credibility": {
            "description": "Den menneskelige viden forstærker AI-teknologien, og du vil altid have det sidste ord",
            "header": "Baseret på Karnovs indhold"
          },
          "security": {
            "description": "KAILA sikrer dine data gennem striks datastyring",
            "header": "Der passes godt på dine data"
          },
          "feedback": {
            "description": "Bedøm de genererede svar og fortæl os hvad vi kan forbedre",
            "header": "Hjælp os med at forbedre KAILA med din feedback"
          }
        }
      }
    },
    "read_more_label": "Læs mere"
  },
  "header": {
    "goto_main_content": "Gå til indholdet"
  },
  "user_menu": {
    "logout": "Log ud",
    "go_to_platform": "Karnov Online",
    "redirect_to_login": "Opdater Adgang",
    "theme_selector": {
      "appearance": "Udseende",
      "theme": {
        "dark": "Mørk",
        "light": "Lys",
        "system": "System"
      }
    },
    "language_selector": {
      "content": "indhold",
      "header": "Sprog",
      "languages": {
        "da": "Dansk",
        "es": "Spansk",
        "fr": "Fransk",
        "sv": "Svensk",
        "no": "Bokmål (norsk)",
        "nn": "Nynorsk (norsk)"
      }
    },
    "go_to_flow": "KAILA Flow",
    "learn_about_flow": "Lær mere om vores nye løsning",
    "badge": "Nyhed"
  },
  "platform_name": "KAILA",
  "document_analysis": {
    "select_document_analysis_mode": "Vælg en analysemulighed",
    "hero_banner": {
      "intro": "Karnov introducerer",
      "headline": "KAILA Dokumentanalyse",
      "description": "Vores eksperter har udviklet unikke analysemuligheder, der hjælper dig med at omsætte kompleks jura til konkrete løsninger."
    },
    "file_upload_header": {
      "description": "Upload din kontrakt for at komme i gang",
      "title": "Kontraktgennemgang"
    },
    "use_prompt_button": "Vælg analyse",
    "see_example_button": "Se eksempel",
    "back_to_document_analysis_list": "Tilbage til Dokumentanalyser",
    "options": {
      "contract_review": {
        "title": "Analysér kontrakter",
        "description": "Få en hurtig, klausul-for-klausul gennemgang af din kontrakt. For hver klausul henter KAILA de vigtigste kilder, markerer mulige risici, vurderer risikoniveau – høj, mellem, lav - og foreslår konkrete forbedringer. Du får en overskuelig vurdering af hele kontrakten, med klare anbefalinger og dokumenterede kilder.",
        "guide": "Ud over det uploadede dokument kan du tilføje supplerende oplysninger, fx kontrakttype og part, samt andre relevante omstændigheder, som ikke fremgår af dokumentet.",
        "example_text": "Her ses et eksempel på en analyse. Det giver overblik over KAILAs svar, så du kan vurdere, om det passer til dine behov.",
        "placeholder": "Tilføj supplerende oplysninger"
      },
      "document_compliance": {
        "title": "Analysér compliancepolitik",
        "description": "Analysér og sammenhold din compliance politik med relevante retskilder. KAILA leverer en rapport i tre dele: et kort resume, en oversigtstabel med risikovurdering og en liste med tydelige løsningsforslag. Du får et komplet overblik, så du ved, hvad næste skridt er.",
        "guide": "Ud over det uploadede dokument kan du tilføje supplerende oplysninger, fx hvilken part du er, eller andre relevante omstændigheder, som ikke fremgår af dokumentet.",
        "example_text": "",
        "placeholder": "Tilføj supplerende oplysninger"
      },
      "argument_strengthener": {
        "title": "Styrk argumenter",
        "description": "Få en hurtig gennemgang af dine argumenter. KAILA gennemgår dine argumenter, sammenholder dem med relevante retskilder og finder argumenternes svagheder. Du får stærkere argumenter, der er veldokumenterede med nøjagtige henvisninger til Karnovs indhold.",
        "guide": "Ud over det uploadede dokument kan du tilføje supplerende oplysninger, fx hvilken part du er, eller andre relevante omstændigheder, som ikke fremgår af dokumentet.",
        "example_text": "",
        "placeholder": "Tilføj supplerende oplysninger"
      },
      "weakness_finder": {
        "title": "Find svagheder",
        "description": "Find de steder, hvor argumentationen er svag eller mangelfuld. KAILA gennemgår modpartens argumenter og kommer med modargumenter, foreslår mulige angrebsvinkler og hjælper med at formulere de bedste argumenter med konkrete kildehenvisninger. Du får en strategi til at udnytte modpartens svagheder – dokumenteret og klar til brug.",
        "guide": "Ud over det uploadede dokument kan du tilføje supplerende oplysninger, fx hvilken part du er, eller andre relevante omstændigheder, som ikke fremgår af dokumentet.",
        "example_text": "",
        "placeholder": "Tilføj supplerende oplysninger"
      }
    }
  },
  "workspace_promo_banner": {
    "text": "Kom i gang med KAILA Flow",
    "link": "Læs mere",
    "badge": "Nyhed"
  },
  "prompt_suggestions": {
    "kaila": {
      "title": "Find svar til din juridiske informationssøgning",
      "description": "Lad dig inspirere af disse forslag",
      "templates": [
        {
          "category": "book-section",
          "prompt": "Jeg har brug for en oversigt over forskellen på reglerne om aktindsigt i henholdsvis offentlighedsloven og forvaltningsloven. Jeg skal bruge det som en tabel.",
          "sample": "Jeg skal bruge en oversigt over forskellen på reglerne om aktindsigt i offentlighedsloven og forvaltningsloven."
        },
        {
          "category": "scale-unbalanced-flip",
          "prompt": "Jeg skal bruge de bedste argumenter for, at min klient kan få den laveste straf for at bære en kniv på gaden. Min klient blev stoppet af politiet i et rutinetjek. Der var tale om en kniv, som normalt anvendes til arbejde. Min klient blev stoppet af politiet en tirsdag formiddag. Det skete på en befærdet gade i centrum af en by.",
          "sample": "Jeg har brug for inspiration til argumenter, der skal sikre min klient den laveste straf."
        },
        {
          "category": "scale-unbalanced-flip",
          "prompt": "Hvordan skal væsentlighedskravet i erhvervslejelovens § 13 fortolkes?",
          "sample": "Jeg skal bruge en redegørelse for væsentlighedskravet i erhvervslejelovens § 13."
        },
        {
          "category": "book-section",
          "prompt": "Jeg skal bruge et udkast til klage til en kommune i forbindelse med afslag på tilskud til talepædagog til et barn. Barnet er tre år og har nedsat hørelse, den ene forælder er uden arbejde og den anden forælder er ikke en del af barnets liv. Inkluder relevant lovgivning i udkastet.",
          "sample": "Jeg har brug for et forslag til klage i forbindelse med afslag på tilskud til talepædagog til et mindreårigt barn."
        }
      ]
    },
    "kfc": {
      "title": "Find svar på tværs af lovgivning og kommunens egne dokumenter",
      "description": "Lad dig inspirere af disse forslag",
      "templates": [
        {
          "category": "book-section",
          "prompt": "Må en kontanthjælpsmodtager, som opfylder betingelserne for ferie, først afholde 14 dages ferie med ydelse og bagefter 14 dage uden ydelse?",
          "sample": "Må en kontanthjælpsmodtager, som opfylder betingelserne for ferie, først afholde 14 dages ferie med ydelse og bagefter 14 dage uden ydelse?"
        },
        {
          "category": "book-section",
          "prompt": "Er udstrækningsøvelser for at kunne vedligeholde basale funktioner som påklædning bad osv. en ydelse efter servicelovens § 83 eller servicelovens § 86? ",
          "sample": "Er udstrækningsøvelser for at kunne vedligeholde basale funktioner som påklædning bad osv. en ydelse efter servicelovens § 83 eller servicelovens § 86? "
        },
        {
          "category": "book-section",
          "prompt": "Hvilke forhold skal kommunen være særlig opmærksom på i sin afgørelse om nedlæggelsen af en privat fællesvej? ",
          "sample": "Hvilke forhold skal kommunen være særlig opmærksom på i sin afgørelse om nedlæggelsen af en privat fællesvej? "
        },
        {
          "category": "book-section",
          "prompt": "Hvilke krav til behandlingen af personoplysninger findes ved manuel videregivelse af oplysninger om enkeltpersoner fra en kommune til en anden forvaltningsmyndighed?",
          "sample": "Hvilke krav til behandlingen af personoplysninger findes ved manuel videregivelse af oplysninger om enkeltpersoner fra en kommune til en anden forvaltningsmyndighed?"
        }
      ]
    },
    "replay": {
      "title": "Genafspil tidligere samtaler der er gemt lokalt på din enhed",
      "description": "Skriv indexet på en tidligere samtale, som du vil genafspille.",
      "templates": [
        {
          "category": "scale-unbalanced-flip",
          "prompt": "example",
          "sample": "Example"
        },
        {
          "category": "scale-unbalanced-flip",
          "prompt": "error",
          "sample": "Error"
        }
      ]
    },
    "mock": {
      "title": "Test rendering af forskellige prompt",
      "description": "Test forskellige use-cases med disse eksempler",
      "templates": [
        {
          "category": "scale-unbalanced-flip",
          "prompt": "test",
          "sample": "test"
        },
        {
          "category": "book-section",
          "prompt": "gfm",
          "sample": "Git flavoured markdown"
        },
        {
          "category": "scale-unbalanced-flip",
          "prompt": "invalid",
          "sample": "Invalid response"
        },
        {
          "category": "book-section",
          "prompt": "markdown",
          "sample": "markdown"
        },
        {
          "category": "siren-on",
          "prompt": "markdown-malformed",
          "sample": "Invalid & malformed markdown"
        },
        {
          "category": "siren-on",
          "prompt": "markdown-error",
          "sample": "Component that throws an uncaught exception"
        },
        {
          "category": "table",
          "prompt": "table",
          "sample": "table"
        },
        {
          "category": "scale-unbalanced-flip",
          "prompt": "details",
          "sample": "details"
        },
        {
          "category": "scale-unbalanced-flip",
          "prompt": "stressTest",
          "sample": "stress test"
        },
        {
          "category": "scale-unbalanced-flip",
          "prompt": "markdownAndInlineReferences",
          "sample": "Inline references after markdown elements"
        },
        {
          "category": "scale-unbalanced-flip",
          "prompt": "refsList",
          "sample": "Inline references in list"
        },
        {
          "category": "book-section",
          "prompt": "new-refsList",
          "sample": "New reference mdx format"
        }
      ] 
    }
  },
  "errors": {
    "footer": {
      "title": "Vi sidder klar til at hjælpe",
      "description": "Er du stødt på problemer så kontakt kundeservice på {{telephone}} eller {{email}}",
      "email": "kundeservice@karnovgroup.com",
      "telephone": "33 74 07 00"
    },
    "auth": {
      "no_session": {
        "title": "",
        "subtitle": "",
        "description": ""
      },
      "default": {
        "title": "Vi kunne ikke logge dig ind",
        "subtitle": "",
        "description": "Der opstod en fejl under login. Prøv venligst igen eller kontakt kundesupport hvis problemet fortsætter."
      }
    }
  },
  "close_service_message_banner": "Luk besked",
  "upload_modal": {
    "attachment_limit_exceeded_warning": "Du har nået grænsen på {{attachmentLimit}} dokumenter pr. spørgsmål. Fjern et dokument, før du uploader et nyt.",
    "close_modal_button_label": "Udført",
    "description": "Du kan uploade op til {{attachmentLimit}} dokumenter afhængigt af deres størrelse.",
    "done_button": "Udført",
    "file_browser": {
      "browse_files": "Gennemse",
      "description": "Understøttede filtyper: .pdf og .docx",
      "header": "Klik for at uploade dokumenter"
    },
    "capacity_indicator": {
      "attachment_count": "{{count}}/{{limit}} Dokumenter",
      "tooltip": "Hvert dokument optager en procentdel af din samlede uploadgrænse, baseret på antal ord – ikke filstørrelse. Lange dokumenter fylder derfor mere, så du kan nå 100% før du har uploadet 10 filer.",
      "used_capacity": "plads brugt"
    },
    "file_upload_button_tooltip": "Upload filer",
    "header": "Upload filer",
    "open_modal_button": "Upload filer",
    "onboarding_tooltip": "Nyhed: Du kan nu uploade op til 10 filer pr. spørgsmål",
    "reinsurance_label": "Dine filer er krypterede",
    "reinsurance_tooltip": "Karnov Group beskytter fortroligheden af alle kundedata, herunder brugerindtastninger, genererede data og dokumenter, ved hjælp af stærk kryptering, der lever op til gældende standarder."
  },
  "prompt_input_with_document_references": {
    "add_document_references_button": {
      "label": "Henvis til dokumenter",
      "tooltip": "Klik for at henvise til et dokument",
      "onboarding_tooltip": "Vi har gjort det enklere at henvise til dokumenter."
    }
  }, 
  "document_references_modal": {
    "description": "Ved at henvise til dokumenter kan du få et mere præcist svar",
    "close_modal_button_label": "Afslut",
    "document_references_count": "Valgte henvisninger ({{count}})",
    "done_button": "Afslut",
    "empty_state": {
      "header": "Inddrag en kilde i svaret",
      "description": "Du kan bruge denne funktion, hvis du vil være sikker på, at én eller flere kilder inddrages i svaret fra KAILA."
    },
    "header": "Henvis til dokumenter",
    "remove_document_reference_button": "Fjern henvisning",
    "search": {
      "fetching_suggestions": "Henter dokumenter...",
      "input_label": "Søg efter et dokument",
      "input_placeholder": "Skriv dokumentets navn her",
      "error": {
        "description": "Forsøg at genindlæse siden",
        "title": "Noget gik galt"
      },
      "empty_search": {
        "description": "Skriv en gyldig titel eller reference, eller gå till Karnov Online og find dokumentet.",
        "kfc_disclaimer": "Kaila har allerede adgang til dine lokale dokumenter, så de behøver ikke at blive tagget.",
        "title": "Fandt ingen dokumenter"
      }
    }
  },
  "message_resources": {
    "remove_message_resource": {
      "attachment": "Fjern dokument",
      "document_reference": "Fjern henvisning"
    },
    "open_modal": {
      "attachment": "Se dokumenter",
      "document_reference": "Se henvisninger"
    },
    "placeholder": {
      "label": {
        "attachment": "{{count}} uploadede filer",
        "document_reference": "{{count}} henviste dokumenter"
      },
      "tooltip": {
        "attachment": "Se alle uploadede filer",
        "document_reference": "Se alle henviste dokumenter"
      }
    }
  },
  "search": {
    "clear_input": "Ryd søgetekst",
    "placeholder": "Søg..."
  }
}
